import { render, staticRenderFns } from "./GradeScaleType.vue?vue&type=template&id=589fa622"
import script from "./GradeScaleType.vue?vue&type=script&lang=js"
export * from "./GradeScaleType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports